import * as yup from "yup";

export const registerSchema = (states, counties, titleReps, trans) => {
  if (typeof trans !== "function") {
    console.warn(
      "⚠️ Translation function not provided — falling back to English defaults."
    );
    trans = (key) => key; // fallback to avoid crash
  }

  return yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .required(trans("validation_first_name_required")),
    last_name: yup
      .string()
      .trim()
      .required(trans("validation_last_name_required")),
    email: yup
      .string()
      .email(trans("validation_email_invalid"))
      .required(trans("validation_email_required")),
    confirmEmail: yup
      .string()
      .oneOf([yup.ref("email"), null], trans("validation_email_mismatch"))
      .required(trans("validation_confirm_email_required")),
    username: yup
      .string()
      .required(trans("validation_username_required"))
      .min(6, trans("validation_username_min")),
    password: yup
      .string()
      .required(trans("validation_password_required"))
      .min(6, trans("validation_password_min"))
      .matches(/[a-z]/, trans("validation_password_lowercase"))
      .matches(/\d/, trans("validation_password_number"))
      .matches(/[=!\-@._&%$#?'"<>^*]/, trans("validation_password_special")),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], trans("validation_password_mismatch"))
      .required(trans("validation_confirm_password_required")),
    mailing_address: yup
      .string()
      .trim()
      .required(trans("validation_mailing_address_required")),
    city: yup
      .string()
      .matches(/^[a-zA-Z \-']+$/, trans("validation_city_invalid"))
      .required(trans("validation_city_required")),
    state: yup.string().required(trans("validation_state_required")),
    county: yup.string().required(trans("validation_county_required")),
    postal_code: yup
      .string()
      .required(trans("validation_postal_code_required")),
    phone: yup
      .string()
      .required(trans("validation_phone_required"))
      .test("phone-length", trans("validation_phone_invalid"), (value) => {
        if (!value) return false;
        const digits = value.replace(/[^0-9]/g, "");
        return digits.length >= 10 && digits.length <= 12;
      }),
    office_name: yup.string().required(trans("validation_office_required")),
    titlerep: yup.string().required(trans("validation_titlerep_required")),
    dre_nmls: yup.string(),
    corporate_nmls: yup.string(),
  });
};

export const profileRegisterSchema = (states, counties, titleReps, trans) => {
  if (typeof trans !== "function") {
    console.warn(
      "⚠️ Translation function not provided — falling back to English defaults."
    );
    trans = (key) => key; // fallback to avoid crash
  }

  return yup.object().shape({
    first_name: yup
      .string()
      .trim()
      .required(trans("validation_first_name_required")),
    last_name: yup
      .string()
      .trim()
      .required(trans("validation_last_name_required")),
    email: yup
      .string()
      .email(trans("validation_email_invalid"))
      .required(trans("validation_email_required")),
    username: yup
      .string()
      .required(trans("validation_username_required"))
      .min(6, trans("validation_username_min")),
    mailing_address: yup
      .string()
      .trim()
      .required(trans("validation_mailing_address_required")),
    city: yup
      .string()
      .matches(/^[a-zA-Z \-']+$/, trans("validation_city_invalid"))
      .required(trans("validation_city_required")),
    state: yup.string().required(trans("validation_state_required")),
    county: yup.string().required(trans("validation_county_required")),
    postal_code: yup
      .string()
      .required(trans("validation_postal_code_required")),
    phone: yup.string().required(trans("validation_phone_required")),
    office_name: yup.string().required(trans("validation_office_required")),
    titlerep: yup.string().required(trans("validation_titlerep_required")),
    dre_nmls: yup.string(),
    corporate_nmls: yup.string(),
  });
};
